export default __webpack_public_path__ + "static/media/A-graphic-small.24947c96.svg";